<template>
  <div style="margin-top:10px">
        <ul>
            <li v-for="i in bidding" :key="i.time" style="display:flex">
                <div style="margin-right:10px;">{{i.time}}</div>
                <div>{{i.msg}}</div>
            </li>
        </ul>
    </div>
</template>

<script>
  import request from '@/utils/request'
  export default {
    name: "biddingProFile",
    data () {
      return {
            bidding:{},
      }
    },
    mounted () {
      this.getptcInfo()
    },
    methods: {
        async getptcInfo(){
          let data = await request({
            url: '/xmgl/pds/getbiddingProList',
            method: "get",
            params: {projectcode:this.$route.query.projectcode}
          })
          if(data){
              this.bidding = data.message.common
              this.bidding = this.bidding.sort((a,b)=>{
                return b.time < a.time ? 1 : -1
              })
          }
        },
    }
  }
</script>

<style lang="scss" scoped>
</style>
